var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "row flexbox-container" }, [
    _c(
      "div",
      { staticClass: "col-xl-8 col-11 d-flex justify-content-center" },
      [
        _c("div", { staticClass: "card bg-authentication rounded-0 mb-0" }, [
          _c("div", { staticClass: "row m-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 col-12 p-0" }, [
              _c("div", { staticClass: "card rounded-0 mb-0 px-2 py-1" }, [
                _c("div", { staticClass: "card-header pb-1" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.trans("auth.two_factor_security"))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("center", { staticClass: "m-t-30" }, [
                        _c("img", {
                          staticClass: "rounded-circle img-border box-shadow-1",
                          attrs: {
                            src: _vm.getAuthUser("avatar"),
                            width: "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("h4", { staticClass: "card-title m-t-10" }, [
                          _vm._v(_vm._s(_vm.getAuthUser("full_name"))),
                        ]),
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          attrs: { id: "twoFactorForm" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                            keydown: function ($event) {
                              return _vm.twoFactorForm.errors.clear(
                                $event.target.name
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "fieldset",
                            {
                              staticClass:
                                "form-label-group form-group position-relative has-icon-left",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.twoFactorForm.two_factor_code,
                                    expression: "twoFactorForm.two_factor_code",
                                  },
                                ],
                                staticClass: "form-control text-center",
                                class: {
                                  "is-invalid":
                                    _vm.twoFactorForm.errors.has(
                                      "two_factor_code"
                                    ),
                                },
                                attrs: {
                                  type: "text",
                                  name: "two_factor_code",
                                  placeholder: _vm.trans(
                                    "auth.two_factor_code"
                                  ),
                                  autocomplete: "two_factor_code",
                                  autofocus: "",
                                },
                                domProps: {
                                  value: _vm.twoFactorForm.two_factor_code,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.twoFactorForm,
                                      "two_factor_code",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "two_factor_code" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.trans("auth.two_factor_code"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.twoFactorForm,
                                  "prop-name": "two_factor_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "float-md-left d-block mb-1" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-outline-primary btn-block px-75",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.logout.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fas fa-power-off" }),
                                  _vm._v(
                                    " " + _vm._s(_vm.trans("auth.logout"))
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "float-md-right d-block mb-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary btn-block px-75",
                                  attrs: { type: "submit" },
                                },
                                [_vm._v(_vm._s(_vm.trans("auth.confirm")))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "col-lg-6 d-lg-block d-none text-center align-self-center",
      },
      [
        _c("img", {
          attrs: {
            src: "/images/pages/login.jpeg",
            width: "332px",
            alt: "branding logo",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-control-position" }, [
      _c("i", { staticClass: "feather icon-lock" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }